import { images } from "../../../../Assets/assetsHelper";
import "./MissionJudging.css";
import { BarLoader } from "react-spinners";
import { useNavigate } from "react-router";
import { display, fontSize, maxWidth } from "@mui/system";
import { Autocomplete, Box, Rating, Typography, Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import TripOriginIcon from "@mui/icons-material/TripOrigin";
import CircleIcon from "@mui/icons-material/Circle";
import { useEffect, useState } from "react";
import PrimaryButton from "../../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import TextArea from "../../../../Components/Atoms/Inputs/TextArea/TextArea";
import { toast } from "react-toastify";
import useSave from "../../../../Hooks/useSave";
import TextFieldInput from "../../../../Components/Atoms/Inputs/TextField/TextFieldInput";

// Utility function to calculate optimal number of rating buttons
const calculateOptimalRatingButtons = (maxValue) => {
  // Always return 5 rating buttons
  return maxValue >= 10 ? 10 : 5;
};

const AttributeRating = ({ attribute, i, setScores, scores, isEdit }) => {
  // const [value, setValue] = useState(null);
  const [hover, setHover] = useState(-1);
  const attributeUsed = {
    id: isEdit ? attribute?.reportAttributeId : attribute?.id,
    maxValue: attribute?.maxValue,
    name: attribute?.name,
    value: attribute?.value,
  };

  const maxValue = attributeUsed?.maxValue || 10;
  const optimalRatingButtons = calculateOptimalRatingButtons(maxValue);
  const divisor = maxValue / optimalRatingButtons;

  return (
    <>
      <TableContainer component={Paper} sx={{ marginBottom: { xs: "5px" } }}>
        <Table aria-label="simple table">
          <TableBody>
            <TableRow>
              <TableCell
                align="left"
                sx={{
                  padding: { xs: "10px 10px 4px" },
                  fontSize: { xs: "15px", md: "18px" },
                  display: { xs: "block", md: "flex" },
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: "space-between",
                }}
              >
                {i + 1} - {attributeUsed?.name}
                <span className="scoreSmall">
                  {scores?.find(
                    (item) => item?.reportAttributeId == attributeUsed?.id
                  )?.value ?? 0}
                  /{attributeUsed?.maxValue}
                </span>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Rating
                  className="rating"
                  name="hover-feedback"
                  value={
                    maxValue >= 10
                      ? Math.round(
                          (scores?.find(
                            (item) =>
                              item?.reportAttributeId == attributeUsed?.id
                          )?.value ?? 0) / divisor
                        )
                      : scores?.find(
                          (item) => item?.reportAttributeId == attributeUsed?.id
                        )?.value ?? 0
                  }
                  onChange={(event, newValue) => {
                    setScores([
                      ...scores?.filter(
                        (item) => item?.reportAttributeId != attributeUsed?.id
                      ),
                      {
                        reportAttributeId: attributeUsed?.id,
                        value:
                          maxValue >= 10
                            ? Math.ceil(newValue * divisor)
                            : newValue,
                      },
                    ]);
                  }}
                  icon={<CircleIcon fontSize="inherit" />}
                  emptyIcon={<TripOriginIcon fontSize="inherit" />}
                  onChangeActive={(event, newHover) => {
                    setHover(maxValue >= 10 ? newHover * divisor : newHover);
                  }}
                  max={optimalRatingButtons}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

function MissionJudging({
  loading,
  url,
  team,
  id,
  scores,
  setScores,
  note,
  setNote,
  handleSubmit,
  addLoading,
  setAward,
  award,
  absent,
  setAbsent,
  setGoSave,
  groups,
  isEdit,
}) {
  return (
    <div className="mainContainer">
      {team && !loading ? (
        <div className="Cont">
          <Box className="missionInfoSection">
            <Grid container spacing={1}>
              {/* Basic Information */}
              <Grid item xs={12}>
                <Box className="missionSettingsHeader">
                  <h3 className="missionSettingsTitle">Basic Information</h3>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Mission Name
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {team?.mission?.name || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Mission Number
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {team?.mission?.order || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Category
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {team?.team?.category?.name || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Age Group
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {team?.team?.category?.ageGroup?.name || "-"}
                  </Typography>
                </Box>
              </Grid>

              {/* Team Information */}
              <Grid item xs={12}>
                <Box className="missionSettingsHeader">
                  <h3 className="missionSettingsTitle">Team Information</h3>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Team Name
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {team?.team?.name || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Team Code
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {team?.team?.code || "-"}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box className="missionInfoItem">
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#6b7280",
                      fontSize: "12px",
                      marginBottom: "4px",
                      fontWeight: 500,
                    }}
                  >
                    Absent
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "var(--text-primary)",
                      fontWeight: 600,
                      fontSize: "15px",
                    }}
                  >
                    {team?.absent || "No"}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ width: "100%", marginTop: "20px" }}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
              <PrimaryButton
                classBtn={"center studentButton"}
                text={"Make Team Absent"}
                style={{
                  textTransform: "capitalize",
                  borderRadius: "5px",
                  color: "var(--text-secondary)",
                  backgroundColor: "var(--primary)",
                  height: "40px",
                  padding: "0 15px",
                  minWidth: "100px",
                  textWrap: "noWrap",
                }}
                click={() => {
                  const confirmed = window.confirm(
                    "Are you sure you want to mark this team as absent?"
                  );
                  if (confirmed) {
                    setAbsent(true);
                    setGoSave(true);
                  }
                }}
              />
            </Box>
            {!team?.absent ? (
              <>
                <Box sx={{ width: "100%" }}>
                  <Box className="missionInfoSection">
                    <Box className="missionSettingsHeader">
                      <Typography
                        variant="h3"
                        className="missionSettingsTitle"
                        sx={{
                          fontSize: { xs: "20px", md: "25px" },
                          fontWeight: "700",
                        }}
                      >
                        Scoring Sheet
                      </Typography>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: "20px", md: "25px" },
                          fontWeight: "700",
                          color: "var(--text-primary)",
                        }}
                      >
                        Total:{" "}
                        {scores
                          ?.map((item) => item?.value)
                          ?.reduce((a, b) => a + b, 0)}
                        /
                        {isEdit
                          ? team?.maxTotalValue
                          : team?.report?.reportMaxValue}
                      </Typography>
                    </Box>
                  </Box>

                  <Box sx={{ marginTop: "16px" }}>
                    {groups?.map((group, i) => (
                      <Box key={i} className="missionInfoSection" sx={{ marginBottom: "16px" }}>
                        <Box className="missionSettingsHeader">
                          <Typography
                            variant="h4"
                            className="missionSettingsTitle"
                            sx={{
                              fontSize: { xs: "17px", md: "22px" },
                              fontWeight: "600",
                            }}
                          >
                            {i + 1} - {group?.name}
                          </Typography>
                        </Box>
                        <Box sx={{ marginTop: "12px" }}>
                          {group?.attributes?.map((attribute, a) => (
                            <Box key={a} sx={{ marginBottom: "12px" }}>
                              <AttributeRating
                                attribute={attribute}
                                i={a}
                                setScores={setScores}
                                scores={scores}
                                isEdit={isEdit}
                              />
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    ))}

                    <Box className="missionInfoSection">
                      <Box className="missionSettingsHeader">
                        <Typography
                          variant="h4"
                          className="missionSettingsTitle"
                          sx={{
                            fontSize: { xs: "17px", md: "22px" },
                            fontWeight: "700",
                          }}
                        >
                          {groups?.length + 1} - Write Your Note:
                        </Typography>
                      </Box>
                      <Box sx={{ marginTop: "12px" }}>
                        <TextArea
                          Required
                          name="text"
                          placeholder={"Enter your note about this team.."}
                          classes="textAreaInputFull"
                          label="Note"
                          newValue={note}
                          change={(e) => {
                            setNote(e.target.value);
                          }}
                        />
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        marginTop: "20px",
                      }}
                    >
                      <PrimaryButton
                        classBtn={"center addButton"}
                        btnType={"submit"}
                        text={isEdit ? "Edit" : "Submit"}
                        loading={addLoading}
                        click={handleSubmit}
                        style={{
                          textTransform: "capitalize",
                          width: "50%",
                          borderRadius: "5px",
                          color: "var(--text-secondary)",
                          backgroundColor: "var(--primary)",
                          maxWidth: "200px",
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </>
            ) : (
              ""
            )}
          </Box>
        </div>
      ) : (
        <div className="loadingBox">
          <BarLoader color="var(--primary)" />
        </div>
      )}
    </div>
  );
}

export default MissionJudging;
